import Vue from "vue";
import Router from "vue-router";
import Store from "../util/store";

import { PersonalCenterRoutes } from "@/pages/PersonalCenter/router/PersonalCenter.routes";
import { AgencyCenterRoutes } from "@/pages/AgencyCenter/router/AgencyCenter.routes";
import { CourseCenterRoutes } from "@/pages/CourseCenter/router/CourseCenter.routes";
import { ActivityGameRoutes } from "@/pages/ActivityGame/router/ActivityGame.routes";
import { NewsCenterRoutes } from "@/pages/NewsCenter/router/NewsCenter.routes";
import { EvaluationCenterRoutes } from "@/pages/EvaluationCenter/router/EvaluationCenter.routes";
import { yihaiRoutes } from "@/pages/yiHai/router/yihai.routes";
import { PayCenterRoutes } from "@/pages/PayCenter/router/PayCenter.routes";
import { messageCenterRoutes } from "@/pages/message/router/message.router";
import { ContactRoutes } from "@/pages/Contact/router/Contact.routes";
// import smsLogin from '../pages/login/smsLogin'
// import smsAuthentication from '../pages/login/smsAuthentication'
// import toLogin from '../pages/login/toLogin'
// import Register from '../pages/login/indRegistration'
// import password from '../pages/login/password'

import { Admin } from "@/pages/Admin/router/Admin.routes";
import { MobileRoutes } from "@/pages/Mobile/router/Mobile.routes";

import { Form } from "view-design";
import form from "view-design/src/mixins/form";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

const router = new Router({
  // mode: "history",  // 消除地址栏中的“#”
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/pages/index"),
    },
    ...PersonalCenterRoutes, // 个人中心路由
    ...AgencyCenterRoutes, // 合作单位路由
    ...CourseCenterRoutes, // 素质培养
    ...ActivityGameRoutes, //活动比赛路由
    ...NewsCenterRoutes, // 新闻中心路由
    ...yihaiRoutes, //名师风范路由
    ...PayCenterRoutes, //支付中心路由
    ...EvaluationCenterRoutes, //素质测评
    ...ContactRoutes, // 联系我们
    ...Admin,
    ...messageCenterRoutes, // 消息通知
    ...MobileRoutes,
    /*  {
            path: '/login', component: smsLogin
        }, {
            path: '/smsAuthentication',
            name: 'smsAuthentication',
            component: smsAuthentication
        }, {
            path: '/toLogin', component: toLogin
        }, {
            path: '/register', component: Register
        }, {
            path: '/password', component: password
        },*/ {
      path: "*",
      name: "errorPage",
      component: () => import("@/pages/errorPage"),
    },
  ],
});

//全局守卫，记录登录状态
router.beforeEach((to, from, next) => {
  // console.log(111,to, from, next);
  let path = to.path.toLowerCase();
  const tokenStr = Store.getters["sessions/getUserinfo"];
  if (_isMobile()) {
    Store.dispatch("sessions/setShowBackTop", false);
    if (tokenStr) {
      Store.dispatch("sessions/setShowLogin", false);
    } else {
      Store.dispatch("sessions/setShowLogin", true);
    }

    if (path.indexOf("mobile") < 0) {
      next("/Mobile");
    } else {
      next();
    }
  } else {
    Store.dispatch("sessions/setShowBackTop", true);
    if (path.indexOf("mobile") > -1) {
      // console.log(333)
      next("/");
    } else if (path.indexOf("admin") > -1 && tokenStr && !tokenStr.account) {
      next("/");
    } else {
      // console.log(444)
      next();
    }
  }

  //需求登录判断
  if (to.meta.auth) {
    const tokenStr = Store.getters["sessions/getUserinfo"];
    if (tokenStr) {
      Store.dispatch("sessions/setShowLoginPop", false);
      next();
    } else {
      Store.dispatch("sessions/setShowLoginPop", true);
      // next('/toLogin')
      next("/");
    }
  } else {
    Store.dispatch("sessions/setShowLoginPop", false);
    next();
  }
});

function _isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js